import React from 'react'

const CustomMeasurementText = () => {
  return (
    <span><span className="swan-cta-swan-text"></span>Swan | Measurements Saved</span>
  )
}

export default CustomMeasurementText